<template>
  <ECard
    v-if="itemsWithTitle.length > 0"
    as="div"
    :elevation="0"
    class="entity-disambiguation"
  >
    <header class="entity-disambiguation__header">
      <EHeading
        as="h3"
        class="entity-disambiguation__heading"
        data-test-id="entity-disambiguation-heading"
      >
        {{ $t('web.entities.disambiguation.headline') }}
      </EHeading>
    </header>
    <EEntityDisambiguationItem
      v-for="item in itemsWithTitle"
      :id="item.id"
      :key="items[item]"
      :title="item.title"
      :description="item.description"
      :thumbnail-url="item.thumbnailUrl"
      data-test-id="entity-disambiguation-item"
    />
  </ECard>
</template>

<script>
import EHeading from '~~/common/vue/components/heading';
import ECard from '~~/common/vue/components/card';
import EEntityDisambiguationItem from './item';

export default {
  name: 'EEntityDisambiguation',
  components: {
    ECard,
    EHeading,
    EEntityDisambiguationItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    itemsWithTitle() {
      return this.items.filter(({ title }) => !!title);
    },
  },
};
</script>
<style lang="scss" scoped>
$disambiguation-thumbnail-size: 50px;

.entity-disambiguation {
  @include desktop {
    border: solid $border-width var(--color-decorative-border-1);
  }
}

.entity-disambiguation__header {
  padding: $space-s $space-m;

  @include divider(bottom);
}

.entity-disambiguation__heading {
  @include line-clamp(1);

  font-size: $font-m;
  font-weight: $font-weight-m;
  color: var(--color-text-secondary);
}

@include desktop {
  .web__mainline .entity-disambiguation {
    display: none;
  }
}
</style>
